import { inject, observer } from 'mobx-react';
import React from 'react';
import { Instance } from 'mobx-state-tree';
import { PharmacyDetails } from '../../store/models/PharmacyDetails';
import { GroupStore } from '../../store';

interface PharmacyDetailProps {
  pharmacyDetails?: Instance<typeof PharmacyDetails>;
  GroupStore?: Instance<typeof GroupStore>;
  showLevel?: boolean;
  showGroup?: boolean;
}

@inject('GroupStore')
@observer
class PharmacyDetail extends React.Component<PharmacyDetailProps> {
  render() {
    const { pharmacyDetails, showLevel, showGroup, GroupStore } = this.props;
    return (
      <div>
        <div>
          <p />
          <div style={{ fontWeight: 'bold' }}>
            {pharmacyDetails
              ? pharmacyDetails!.apbNumber +
                ' - ' +
                pharmacyDetails!.name +
                (showLevel ? ' (' + pharmacyDetails!.level + ')' : '') +
                (showGroup && GroupStore!.dataList.find((g) => g.groupId === pharmacyDetails.groupId)
                  ? ' - Grp: ' + GroupStore!.dataList.find((g) => g.groupId === pharmacyDetails.groupId)!.name
                  : '')
              : ''}
          </div>
          <div>
            {pharmacyDetails ? pharmacyDetails!.address : ''},&nbsp;
            {pharmacyDetails ? pharmacyDetails!.zipCode : ''}
            &nbsp;{pharmacyDetails ? pharmacyDetails!.city : ''}
          </div>
          <div>Tél.:&nbsp;{pharmacyDetails ? pharmacyDetails!.phone : ''}</div>
        </div>
      </div>
    );
  }
}

export default PharmacyDetail;
